import React, { useCallback, useContext, useEffect, useState } from "react";
import { Container, Button, Form, Modal } from "react-bootstrap";
import PageHeader from "../../components/PageHeader";
import { Context } from '../../store/store';
import { usePoolFetch, useInvest, useIntervalPoolFetch, useListingClaim, useVestingClaim } from '../../hooks/IDOPools';
import { useAllowance } from '../../hooks/useAllowance';
import { usePoolUsdtApprove } from '../../hooks/useApprove';
import DotLoader from "react-spinners/DotLoader";
import PropagateLoader from "react-spinners/PropagateLoader";
import { addMinutes, format, formatDuration, intervalToDuration } from "date-fns";
import { isAddress } from '@ethersproject/address';
import { useWeb3React } from '@web3-react/core';
import { toast } from 'react-toastify';
import BigNumber from 'bignumber.js';
import { useParams } from "react-router-dom";
import "./poolDetails.scss"
import RangeSlider from "../../components/RangeSlider";
import { isMobile } from "react-device-detect";
import ImgInactiveTimeLine from "./images/inactive-timeline.png";
import ImgActiveTimeLine from "./images/active-timeline.png";
import { HashLoader } from "react-spinners";
import { useAddressFetch, useInsertAddress } from "../../hooks/address";
import { PublicKey } from '@solana/web3.js';

const PoolDetailsPage = () => {
    let [poolDetails, setPoolDetails] = useState<any>()
    const [state, dispatch] = useContext(Context);
    const override = `
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

    const { account, chainId } = useWeb3React()
    let { poolName } = useParams<{ poolName: string }>();
    let { poolType } = useParams<{ poolType: string }>();
    const { onFetchPoolDetails } = usePoolFetch()
    const intervalPoolDetails = useIntervalPoolFetch(poolDetails)

    const [isWithdrawOpen, setIsWithdrawOpen] = useState(false);
    const [isTotalVestedOpen, setIsTotalVestedOpen] = useState(false);
    const [investAmount, setInvestAmount] = useState(0)
    const [reciveAmount, setReciveAmount] = useState(0)
    const [requestedApproval, setRequestedApproval] = useState(false)
    const [requestedInvest, setRequestedInvest] = useState(false)
    const [requestedClaim, setRequestedClaim] = useState(false)
    const [requestedWhitelist, setRequestedWhitelist] = useState(false)
    const [approveTxhash, setApproveTxhash] = useState('')
    const [investTxhash, setInvestTxhash] = useState('')
    const [claimTxhash, setClaimTxhash] = useState('')
    const [whitelistTxhash, setWhitelistTxhash] = useState('')
    const [whitelistAddress, setWhitelistAddress] = useState('')
    const [formValidity, setFormValidity] = useState<'INVLAID_AMOUNT' | 'VALID'>('INVLAID_AMOUNT')
    const [whitelistFormValidity, setWhitelistFormValidity] = useState<'INVLAID_ADDRESS' | 'VALID'>('INVLAID_ADDRESS')
    const [poolState, setPoolState] = useState<'TBA' | 'WHITLIST_WILL_OPEN' | 'WHITLIST_IS_ON' | 'POOL_WILL_OPEN' | 'OPEN_INVEST_STAKER' | 'OPEN_STAKER_FCFS' | 'OPEN_INVEST_PUBLIC' | 'CLOSED' | 'FILLED' | 'CLAIM_TO_BE_OPEN' | 'CLAIM_OPEN' | 'CANCELLED'>('TBA')
    const allowance = useAllowance(poolDetails)
    const { onApprove } = usePoolUsdtApprove()
    const { onInvest } = useInvest()
    const { onListingClaim } = useListingClaim()
    const { onVestingClaim } = useVestingClaim()
    const [stepperCount, setStepperCount] = useState(0)


    //SOLANA
    const { onAddressInsert } = useInsertAddress()
    const { onAddressFetch } = useAddressFetch()
    const [isSolanaEditable, setSolanaEditable] = useState(false)
    const [solanaAddress, setSolanaAddress] = useState<any>("")
    const [solanaModalShow, setSolanaModalShow] = useState(false);

    useEffect(() => {
        if (!poolDetails) {
            fetchDetails()
        }
    }, [account])

    useEffect(() => {
        if (requestedClaim && intervalPoolDetails.claimed) {
            setRequestedClaim(false)
        }
        if (requestedInvest && intervalPoolDetails.invetment > 0) {
            setRequestedInvest(false)
        }
        if (poolDetails && JSON.stringify(poolDetails) != JSON.stringify(intervalPoolDetails)) {
            setPoolDetails(intervalPoolDetails)
        }
    }, [intervalPoolDetails])

    useEffect(() => {
        if (!allowance) return
        if (new BigNumber(allowance)?.comparedTo(investAmount) === 1) {
            setRequestedApproval(false)
        }
    }, [allowance])

    const isApproveDoneOrInProgress = function () {
        if (!allowance) return false
        if (new BigNumber(allowance)?.comparedTo(investAmount) === 1 || requestedApproval) {
            // setRequestedApproval(false)
            return true
        } else {
            return false
        }
    }

    const isApproveDone = function () {
        if (!allowance) return false
        if (new BigNumber(allowance)?.comparedTo(investAmount) === 1) {
            return true
        } else {
            return false
        }
    }

    const isApproveOrInvestOrClaimInProgress = function () {
        if (requestedInvest || requestedApproval || requestedClaim) {
            return true
        } else {
            return false
        }
    }

    const isWhitelistInProgress = function () {
        return requestedWhitelist
    }

    useEffect(() => () => console.log("unmount"), []);

    const handleApprove = useCallback(async () => {
        try {
            if (requestedApproval) return
            if (formValidity !== 'VALID') {
                showFormValidityToast(formValidity)
                return
            }
            setRequestedApproval(true)
            console.log(poolDetails.poolAddress)
            let tx = await onApprove(poolDetails.poolAddress)
            if (tx) {
                toast.success("Approve request has been submitted")
                setApproveTxhash(tx.hash)
                let res = await tx.wait(1)
                setRequestedApproval(!(res.status))
            } else {
                setRequestedApproval(false)
            }
        } catch (e: any) {
            setRequestedApproval(false)
            toast.error(e.message)
        }
    }, [onApprove, formValidity, poolDetails])

    const handleInvest = useCallback(async () => {
        try {
            if (requestedApproval) return
            if (!solanaAddress) {
                toast.error("Register your solana address")
                return
            }
            if (formValidity !== 'VALID') {
                showFormValidityToast(formValidity)
                return
            }
            setRequestedInvest(true)
            let tx = await onInvest(
                poolDetails.poolAddress,
                new BigNumber(investAmount).times(new BigNumber(10).pow(18).toString()).toString()
            )
            if (tx) {
                toast.success("Invest request has been submitted")
                setInvestTxhash(tx.hash)
                let res = await tx.wait(1)
                setRequestedInvest(!(res.status))
                fetchDetails(false)
            } else {
                setRequestedInvest(false)
            }
        } catch (e: any) {
            setRequestedInvest(false)
            toast.error(e.message)
        }
    }, [onInvest, formValidity, investAmount, poolDetails, solanaAddress])

    const handleListingClaim = useCallback(async () => {
        try {
            if (requestedClaim) return
            setRequestedClaim(true)
            let tx = await onListingClaim(
                poolDetails.poolAddress
            )
            if (tx) {
                toast.success("Claim request has been submitted")
                setClaimTxhash(tx.hash)
                let res = await tx.wait(1)
                setRequestedClaim(!(res.status))
                fetchDetails(false)
            } else {
                setRequestedClaim(false)
            }
        } catch (e: any) {
            setRequestedClaim(false)
            toast.error(e.message)
        }
    }, [onListingClaim, formValidity, poolDetails])

    const handleVestingClaim = useCallback(async () => {
        try {
            if (requestedClaim) return
            setRequestedClaim(true)
            let tx = await onVestingClaim(
                poolDetails.poolAddress
            )
            if (tx) {
                toast.success("Claim request has been submitted")
                setClaimTxhash(tx.hash)
                let res = await tx.wait(1)
                setRequestedClaim(!(res.status))
                fetchDetails(false)
            } else {
                setRequestedClaim(false)
            }
        } catch (e: any) {
            setRequestedClaim(false)
            toast.error(e.message)
        }
    }, [onVestingClaim, formValidity, poolDetails])

    useEffect(() => {
        console.log(poolState, investAmount, poolDetails && poolDetails.maxGuaranteed)
        if (poolDetails && (poolState === 'OPEN_INVEST_STAKER' && (investAmount > poolDetails.maxGuaranteed || investAmount < 0.01))) {
            setFormValidity('INVLAID_AMOUNT')
        } else if (poolDetails && (poolState === 'OPEN_INVEST_PUBLIC' && (poolState < poolDetails.minInvest || investAmount > poolDetails.maxInvest))) {
            setFormValidity('INVLAID_AMOUNT')
        } else {
            setFormValidity('VALID')
        }
    }, [investAmount, poolDetails, poolState])

    useEffect(() => {
        if (whitelistAddress) {
            let addressArray = whitelistAddress.split("\n")
            console.log(addressArray)
            let allValidAddress = true
            for (let i = 0; i < addressArray.length; i++) {
                if (!isAddress(addressArray[i])) {
                    allValidAddress = false
                    break;
                }
            }
            if (!allValidAddress) {
                setWhitelistFormValidity('INVLAID_ADDRESS')
            } else {
                setWhitelistFormValidity('VALID')
            }
        } else {
            setWhitelistFormValidity('INVLAID_ADDRESS')
        }
    }, [whitelistAddress])

    useEffect(() => {
        if (!poolDetails) { return }
        if (poolDetails.tokenPrice <= 0) { return }
        let amount = investAmount / poolDetails.tokenPrice
        setReciveAmount(amount)
    }, [investAmount, poolDetails])

    useEffect(() => {
        if (poolDetails)
            poolStateCalculate(poolDetails)
    }, [poolDetails])

    const showFormValidityToast = function (formValidity: any) {
        switch (formValidity) {
            case 'INVLAID_AMOUNT':
                toast.error('Please enter valid token amount')
                break;
        }
    }

    const showWhitelistFormValidityToast = function (formValidity: any) {
        switch (formValidity) {
            case 'INVLAID_ADDRESS':
                toast.error('Please enter valid address')
                break;
        }
    }

    const poolStateCalculate = function (poolDetails: any) {
        // 'TO_BE_OPEN' | 'OPEN_INVEST_STAKER' | 'OPEN_INVEST_PUBLIC' | 'OPEN_FILLED' | 'CLOSED' | 'CLAIM_TO_BE_OPEN' | 'CLAIM_OPEN' | 'CANCELLED'
        let whitelistingOpenTime = poolDetails.whitelistingOpenTime
        let whitelistingCloseTime = poolDetails.whitelistingCloseTime
        let poolOpen = poolDetails.openTime
        let poolStakerFCFS = poolDetails.poolStakerFCFS
        let poolOpenPublic = poolDetails.poolOpenPublic
        let poolClose = poolDetails.closeTime
        let listingTime = poolDetails.listingTime
        let nowDate = Date.now()

        if (poolOpen === 0) {
            setPoolState('TBA')
        } else if (whitelistingOpenTime > nowDate) {
            setPoolState('WHITLIST_WILL_OPEN')
        } else if (whitelistingOpenTime < nowDate && whitelistingCloseTime >= nowDate) {
            setStepperCount(1)
            setPoolState('WHITLIST_IS_ON')
        } else if (whitelistingCloseTime <= nowDate && poolOpen >= nowDate) {
            setStepperCount(1)
            setPoolState('POOL_WILL_OPEN')
        } else if (nowDate > poolOpen && nowDate <= poolStakerFCFS) {
            setStepperCount(2)
            setPoolState('OPEN_INVEST_STAKER')
        } else if (nowDate > poolStakerFCFS && nowDate <= poolOpenPublic) {
            setStepperCount(3)
            setPoolState('OPEN_STAKER_FCFS')
        } else if (nowDate > poolOpenPublic && nowDate < poolClose) {
            setStepperCount(4)
            setPoolState('OPEN_INVEST_PUBLIC')
        } else if (nowDate > poolClose && nowDate < listingTime) {
            setStepperCount(4)
            setPoolState('CLOSED')
        } else if (nowDate > listingTime && !poolDetails.lpLiquidityAdded) {
            setStepperCount(4)
            setPoolState('CLAIM_TO_BE_OPEN')
        }

        if (poolOpen !== 0 && nowDate > poolDetails.listingTime) {
            setStepperCount(5)
        }

        if ((Number(poolDetails.totalCollected) + Number(poolDetails.minInvest)) >= poolDetails.hardCap) {
            setStepperCount(4)
            setPoolState('FILLED')
        }

        // if (poolDetails.lpLiquidityAdded) {
        //     setStepperCount(5)
        //     setPoolState('CLAIM_OPEN')
        // }

        if (poolDetails.poolCancelled) {
            setStepperCount(5)
        }
    }

    const fetchDetails = useCallback(async (isLoader = true) => {
        try {
            if (isLoader) dispatch({ type: 'SET_LOADING', payload: true })
            let isExculsivePool = true
            if (poolType == "community") {
                isExculsivePool = false
            }
            let poolDetails: any = await onFetchPoolDetails((poolName).toString(), true, isExculsivePool)
            //SOLANA
            let address = await onAddressFetch(poolDetails.poolAddress)
            if (poolDetails && address) {
                let resSolanaAddress = address.address
                poolDetails.solana = resSolanaAddress
                if (!resSolanaAddress) setSolanaEditable(true)
                if (resSolanaAddress) {
                    setSolanaAddress(resSolanaAddress)
                }
            }
            if (isLoader) dispatch({ type: 'SET_LOADING', payload: false })
            setPoolDetails(poolDetails)
        } catch (e) {
            console.log(e)
            dispatch({ type: 'SET_LOADING', payload: false })
        }
    }, [onFetchPoolDetails])

    const handleMaxButtonClick = function (poolState: any) {
        if (!(poolState === "OPEN_INVEST_PUBLIC" || poolState === 'OPEN_STAKER_FCFS')) {
            setInvestAmount(poolDetails.maxGuaranteed)
        } else if (poolState === "OPEN_INVEST_PUBLIC" || poolState === 'OPEN_STAKER_FCFS') {
            setInvestAmount(poolDetails.maxInvest)
        }
    }

    const handleSolanaSubmit = useCallback(async () => {
        console.log(solanaAddress)
        try {
            setSolanaEditable(false)
            let isValid = await PublicKey.isOnCurve((new PublicKey(solanaAddress)).toBytes())
            if (isValid) {
                let message = await onAddressInsert(poolDetails.poolAddress, solanaAddress)
                toast.success(message)
            } else {
                toast.error("Please enter valid solana address")
            }
        } catch (e: any) {
            setSolanaEditable(true)
            console.log(e)
            toast.error(e.message)
        }
    }, [onAddressInsert, poolDetails, solanaAddress])

    return (
        <Container fluid className='brand-bgcolor-shadow-black pools-bg'>
            {!poolDetails && (<PageHeader title={"IDO"} />)}
            {poolDetails && (<PageHeader title={"$" + poolDetails.tokenSymbol + " IDO"} />)}
            <section className="section illustration-section-01">
                <div className="container">
                    {state.loading && account && !poolDetails && <div className="loading-container loading-container-pool-details">
                        <HashLoader color={"#C2EAFF"} loading={state.loading} css={override} />
                    </div>}
                    {poolDetails && (
                        <>
                            <div className="project-details-page">
                                <div className="row title-details mr-0">
                                    <div className="col-md-6 col-sm-12 left-section">
                                        <div className="project-details">
                                            <div className=" d-flex flex-row align-items-center">
                                                <div className="logo-container">
                                                    <img src={poolDetails.logoLink} />
                                                    {/* <p className="mb-0">{poolDetails.chainName}</p> */}
                                                </div>
                                                <div className="text">
                                                    <h4 className="project-title mb-0 font-bold">{poolDetails.title}</h4>
                                                    <p className="project-description mb-0">{poolDetails.description}</p>
                                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                                        <div className="project-social d-flex flex-row justify-content-start mt-2">
                                                            <a className='website' href={poolDetails.website} target='_blank'>
                                                                <div className="social-item d-flex flex-column align-items-center">
                                                                    <img alt="social website" className="social-icon mr-3" src="../images/social-website.png"></img>
                                                                </div>
                                                            </a>
                                                            <a className='twitter' href={"https://twitter.com/" + poolDetails.twitter} target='_blank'>
                                                                <div className="social-item d-flex flex-column align-items-center">
                                                                    <img alt="social twitter" className="social-icon mr-3" src="../images/social-twitter.svg"></img>
                                                                </div>
                                                            </a>
                                                            <a className="telegram" href={"https://telegram.me/" + poolDetails.telegram} target='_blank'>
                                                                <div className="social-item d-flex flex-column align-items-center">
                                                                    <img alt="social telegram" className="social-icon mr-3" src="../images/social-telegram.svg"></img>
                                                                </div>
                                                            </a>
                                                            <a className='pitchdeck' href={poolDetails.pitchDeck} target='_blank'>
                                                                <div className="social-item d-flex flex-column align-items-center">
                                                                    <img alt="social pitchdeck" className="social-icon mr-3" src="../images/social-deck.png"></img>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <a className="register-solana m-0" onClick={() => setSolanaModalShow(true)}>Register Solana Address</a>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12 right-section">
                                        <div className="details-view ">
                                            <div className="detail-item d-flex justify-content-between">
                                                <p className="mb-0">Token Chain</p>
                                                <p className="mb-0">{poolDetails.chainName}</p>
                                            </div>
                                            <div className="detail-item d-flex justify-content-between">
                                                <p className="mb-0">Total Supply</p>
                                                <p className="mb-0">{Number(poolDetails.totalSupply).toLocaleString()} {poolDetails.tokenSymbol}</p>
                                            </div>
                                            <div className="detail-item d-flex justify-content-between">
                                                <p className="mb-0">Token For Sale</p>
                                                <p className="mb-0">{Number(poolDetails.hardCap / poolDetails.tokenPrice).toLocaleString()} {poolDetails.tokenSymbol}</p>
                                            </div>
                                            <div className="detail-item d-flex justify-content-between">
                                                <p className="mb-0">Initial Marketcap</p>
                                                <p className="mb-0">${Number(poolDetails.initialMcap).toLocaleString()}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="stepper-view">
                                    <div className="steppers-container">
                                        <div className="step-item">
                                            <div className="step-item-icon-container">
                                                {stepperCount > 0 && (<img src={ImgActiveTimeLine}></img>)}
                                                {stepperCount <= 0 && (<img src={ImgInactiveTimeLine}></img>)}
                                            </div>
                                            <div className="step-item-text">
                                                <h6 className="title mb-0">whitelist</h6>
                                                <div className="d-flex flex-column">
                                                    {poolDetails.openTime == 0 && (<small>TBA</small>)}
                                                    {poolDetails.openTime != 0 && (
                                                        <>
                                                            <small className="date mb-0">{format(addMinutes(new Date(poolDetails.whitelistingOpenTime), new Date(poolDetails.whitelistingOpenTime).getTimezoneOffset()), 'dd MMM yyyy, HH:mm')} UTC</small>
                                                            <small className="time mb-0">{format(addMinutes(new Date(poolDetails.whitelistingCloseTime), new Date(poolDetails.whitelistingCloseTime).getTimezoneOffset()), 'dd MMM yyyy, HH:mm')} UTC</small>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="step-item">
                                            <div className="step-item-icon-container">
                                                {stepperCount > 1 && (<img src={ImgActiveTimeLine}></img>)}
                                                {stepperCount <= 1 && (<img src={ImgInactiveTimeLine}></img>)}
                                            </div>
                                            <div className="step-item-text">
                                                <h6 className="title mb-0">Round - 1</h6>
                                                <div className="d-flex flex-column">
                                                    {poolDetails.openTime == 0 && (<small>TBA</small>)}
                                                    {poolDetails.openTime != 0 && (
                                                        <>
                                                            <small className="date mb-0">{format(addMinutes(new Date(poolDetails.openTime), new Date(poolDetails.openTime).getTimezoneOffset()), 'dd MMM yyyy')}</small>
                                                            <small className="time mb-0">{format(addMinutes(new Date(poolDetails.openTime), new Date(poolDetails.openTime).getTimezoneOffset()), 'HH:mm')} - {format(addMinutes(new Date(poolDetails.poolStakerFCFS), new Date(poolDetails.poolStakerFCFS).getTimezoneOffset()), 'HH:mm')} UTC</small>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="step-item">
                                            <div className="step-item-icon-container">
                                                {stepperCount > 2 && (<img src={ImgActiveTimeLine}></img>)}
                                                {stepperCount <= 2 && (<img src={ImgInactiveTimeLine}></img>)}
                                            </div>
                                            <div className="step-item-text">
                                                <h6 className="title mb-0">Round - 2</h6>
                                                <div className="d-flex flex-column">
                                                    {poolDetails.openTime == 0 && (<small>TBA</small>)}
                                                    {poolDetails.openTime != 0 && (
                                                        <>
                                                            <small className="date mb-0">{format(addMinutes(new Date(poolDetails.poolStakerFCFS), new Date(poolDetails.poolStakerFCFS).getTimezoneOffset()), 'dd MMM yyyy')}</small>
                                                            <small className="time mb-0">{format(addMinutes(new Date(poolDetails.poolStakerFCFS), new Date(poolDetails.poolStakerFCFS).getTimezoneOffset()), 'HH:mm')} - {format(addMinutes(new Date(poolDetails.poolOpenPublic), new Date(poolDetails.poolOpenPublic).getTimezoneOffset()), 'HH:mm')} UTC</small>
                                                        </>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                        <div className="step-item">
                                            <div className="step-item-icon-container">
                                                {stepperCount > 3 && (<img src={ImgActiveTimeLine}></img>)}
                                                {stepperCount <= 3 && (<img src={ImgInactiveTimeLine}></img>)}
                                            </div>
                                            <div className="step-item-text">
                                                <h6 className="title mb-0">Round - 3</h6>
                                                <div className="d-flex flex-column">
                                                    {poolDetails.openTime == 0 && (<small>TBA</small>)}
                                                    {poolDetails.openTime != 0 && (
                                                        <>
                                                            <small className="date mb-0">{format(addMinutes(new Date(poolDetails.poolOpenPublic), new Date(poolDetails.poolOpenPublic).getTimezoneOffset()), 'dd MMM yyyy')}</small>
                                                            <small className="time mb-0">{format(addMinutes(new Date(poolDetails.poolOpenPublic), new Date(poolDetails.poolOpenPublic).getTimezoneOffset()), 'HH:mm')} - {format(addMinutes(new Date(poolDetails.closeTime), new Date(poolDetails.closeTime).getTimezoneOffset()), ' HH:mm')} UTC</small>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="step-item">
                                            <div className="step-item-icon-container">
                                                {stepperCount > 4 && (<img src={ImgActiveTimeLine}></img>)}
                                                {stepperCount <= 4 && (<img src={ImgInactiveTimeLine}></img>)}
                                            </div>
                                            {poolDetails.poolCancelled && (
                                                <div className="step-item-text">
                                                    <h6 className="title mb-0">Refund</h6>
                                                    <div className="d-flex flex-column">
                                                        {poolDetails.openTime == 0 && (<small>TBA</small>)}
                                                        {poolDetails.openTime != 0 && (
                                                            <>
                                                                <small className="date mb-0">{format(addMinutes(new Date(poolDetails.listingTime), new Date(poolDetails.listingTime).getTimezoneOffset()), 'dd MMM yyyy HH:mm')}</small>
                                                                <small className="time mb-0">Raydium</small>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                            {!poolDetails.poolCancelled && (
                                                <div className="step-item-text">
                                                    <h6 className="title mb-0">Listing</h6>
                                                    <div className="d-flex flex-column">
                                                        {poolDetails.openTime == 0 && (<small>TBA</small>)}
                                                        {poolDetails.openTime != 0 && (
                                                            <>
                                                                <small className="date mb-0">{format(addMinutes(new Date(poolDetails.listingTime), new Date(poolDetails.listingTime).getTimezoneOffset()), 'dd MMM yyyy HH:mm')}</small>
                                                                <small className="time mb-0">Raydium</small>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                        </div>
                                        <div className="connector-line"></div>
                                    </div>
                                </div>

                                <div className="row participation-view">
                                    <div className="col-md-6 col-sm-12 left-section">
                                        <div className="participate-and-progress-view">
                                            <div className="participation-view">
                                                <div className="join-now-container">
                                                    <h6 className="join-now m-0 text-xxs">Participate IDO</h6>
                                                </div>
                                                <div className="participate-now">
                                                    <div className="form-content">
                                                        <div className="">
                                                            <Form className="d-flex flex-column">
                                                                <Form.Group className="mb-1 d-flex flex-column">
                                                                    <Form.Label className='mb-0'>{poolDetails.invetment > 0 ? "You Invested" : "Your Investment"} [USDT]</Form.Label>
                                                                    <Form.Control
                                                                        className="form-input usdt-input"
                                                                        type="number"
                                                                        value={poolDetails.invetment > 0 ? poolDetails.invetment : Number(investAmount)}
                                                                        disabled={poolDetails.invetment > 0}
                                                                        onChange={({ target: { value } }) => {
                                                                            let val = Number(value)
                                                                            setInvestAmount(val)
                                                                        }} />
                                                                </Form.Group>
                                                                {poolDetails.invetment <= 0 && (<Button
                                                                    className="button button-primary button-max"
                                                                    variant="primary"
                                                                    onClick={() => handleMaxButtonClick(poolState)}>MAX</Button>)}
                                                            </Form>
                                                            <h6 className="token-recive-text">Receivable {poolDetails.tokenSymbol}: {poolDetails.invetment > 0 ? (poolDetails.invetment / poolDetails.tokenPrice) + ' ' + poolDetails.tokenSymbol : Number(reciveAmount)}</h6>
                                                        </div>
                                                        {!account && <Button
                                                            className="btn btn-info"
                                                            disabled={true}
                                                        >
                                                            Connect Your Wallet
                                                        </Button>}
                                                        {account && !allowance && <Button
                                                            className="btn btn-info"
                                                            disabled={true}
                                                        >
                                                            Fetching ...
                                                        </Button>}
                                                        {account && allowance && poolState === 'FILLED' && <Button
                                                            className="btn btn-info"
                                                            disabled={true}
                                                        >
                                                            Sold Out
                                                        </Button>}
                                                        {account && allowance && poolState !== 'FILLED' && (((poolState === 'OPEN_INVEST_STAKER' || poolState === 'POOL_WILL_OPEN') && !poolDetails.isWhitlisted) || (poolState === 'OPEN_STAKER_FCFS' && !poolDetails.isRound2Eligible)) && <Button
                                                            className="btn btn-info"
                                                            disabled={true}
                                                        >
                                                            Not Whitelisted
                                                        </Button>}
                                                        {account && allowance && !(((poolState === 'OPEN_INVEST_STAKER' || poolState === 'POOL_WILL_OPEN') && !poolDetails.isWhitlisted) || (poolState === 'OPEN_STAKER_FCFS' && !poolDetails.isRound2Eligible)) && poolState !== 'FILLED' && (<div className="d-flex flex-row">
                                                            <Button
                                                                className="btn btn-brand approve"
                                                                onClick={() => handleApprove()}
                                                                disabled={isApproveDoneOrInProgress() || Date.now() > poolDetails.closeTime}>
                                                                Approve
                                                            </Button>
                                                            {poolDetails.invetment <= 0 && (
                                                                <Button
                                                                    className="btn btn-brand buy"
                                                                    onClick={() => handleInvest()}
                                                                    disabled={!isApproveDone() || Date.now() < poolDetails.openTime || Date.now() > poolDetails.closeTime}>
                                                                    Buy
                                                                </Button>
                                                            )}
                                                            {poolDetails.invetment > 0 && (
                                                                <Button
                                                                    className="btn btn-brand buy"
                                                                    disabled={true}>
                                                                    Buy
                                                                </Button>
                                                            )}
                                                        </div>)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="progress-view">
                                                {(poolState === 'TBA' || poolState === 'WHITLIST_WILL_OPEN' || poolState === 'WHITLIST_IS_ON') && (
                                                    <>
                                                        <div className='d-flex align-items-center'>
                                                            <div className={poolState == 'WHITLIST_IS_ON' ? "w-100 progress-bar-container" : "w-100"}>
                                                                <div>
                                                                    <RangeSlider
                                                                        className="range-slider"
                                                                        custom={true}
                                                                        value={70}
                                                                        type='range'
                                                                        readOnly={true}
                                                                    />
                                                                </div>
                                                                {/* //conditional */}
                                                                <div className='d-flex justify-content-between'>
                                                                    <small className='mb-0'>Exculsive: {70}%</small>
                                                                    <small className='mb-0'>{30}%: Community</small>
                                                                </div>
                                                            </div>
                                                            {poolState == 'WHITLIST_IS_ON' && (
                                                                <div>
                                                                    <a className='btn btn-brand' href="https://blockius.typeform.com/deadknight" target={"_blank"}>Whitelist</a>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </>
                                                )}
                                                {(poolState === 'POOL_WILL_OPEN' || poolState === 'OPEN_INVEST_STAKER' || poolState === 'OPEN_STAKER_FCFS' || poolState === 'OPEN_INVEST_PUBLIC' || poolState === 'CLAIM_OPEN' || poolState === 'CLAIM_TO_BE_OPEN' || poolState === 'FILLED' || poolState === 'CLOSED' || poolState === 'CANCELLED') && (
                                                    <>
                                                        <div>
                                                            <RangeSlider
                                                                className="range-slider"
                                                                custom={true}
                                                                // value={0}
                                                                value={poolDetails.totalCollected > 0 ? poolDetails.totalCollected / poolDetails.hardCap * 100 : 0}
                                                                type='range'
                                                                readOnly={true}
                                                            />
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <small className='mb-0'>{poolDetails.totalCollected > 0 ? (poolDetails.totalCollected / poolDetails.hardCap * 100).toFixed(4) : 0} %</small>
                                                            {/* <div className='pool-type'><h6 className='mb-0'>{poolDetails.isExculsivePool ? "Exclusive" : "Community"}</h6></div> */}
                                                            <small className='mb-0'>{Number(poolDetails.totalCollected).toLocaleString()} / {Number(poolDetails.hardCap).toLocaleString()} USDT</small>
                                                        </div>
                                                    </>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12 right-section">
                                        <div className="allocation-view">
                                            <div className="account-details-container col">
                                                <div className='claim-dashboard-item d-flex'>
                                                    <div className={`first-container flip-container ${isWithdrawOpen ? "flipped" : ""}`}>
                                                        <div className="flipcard-body">
                                                            <div className="front-container">
                                                                <div className="total-withdrawn d-flex align-items-center">
                                                                    <img className="flip-icon" onClick={() => setIsWithdrawOpen(!isWithdrawOpen)} src="../images/icons/right.svg" />
                                                                    <span className='title'>Token Price</span>
                                                                    <span className='withdrawn-amount'>1 {poolDetails.tokenSymbol} = ${(poolDetails.tokenPrice).toFixed(3)}</span>
                                                                </div>
                                                            </div>
                                                            <div className="back-container">
                                                                <div className="total-withdrawn d-flex align-items-center">
                                                                    <img className="flip-icon" onClick={() => setIsWithdrawOpen(!isWithdrawOpen)} src="../images/icons/right.svg" />
                                                                    <span className='title'> {isMobile ? "Accepted Cur." : "Accepted Currency"}</span>
                                                                    <span className='withdrawn-amount'>BSC-USDT</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`second-container flip-container ${isTotalVestedOpen ? "flipped" : ""}`}>
                                                        <div className="flipcard-body">
                                                            <div className="front-container">
                                                                <div className="total-withdrawn d-flex align-items-center">
                                                                    <img className="flip-icon" onClick={() => setIsTotalVestedOpen(!isTotalVestedOpen)} src="../images/icons/right.svg" />
                                                                    {!(poolState === 'OPEN_INVEST_PUBLIC' || poolState === 'OPEN_STAKER_FCFS') && (
                                                                        <>
                                                                            <span className='title'>Allocation</span>
                                                                            <span className='withdrawn-amount'>{poolDetails.maxGuaranteed} USDT</span>
                                                                        </>
                                                                    )}
                                                                    {(poolState === 'OPEN_INVEST_PUBLIC' || poolState === 'OPEN_STAKER_FCFS') && (
                                                                        <>
                                                                            <span className='title'>Maximum</span>
                                                                            <span className='withdrawn-amount'>{poolDetails.maxInvest} USDT</span>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="back-container">
                                                                <div className="total-withdrawn d-flex align-items-center">
                                                                    <img className="flip-icon" onClick={() => setIsTotalVestedOpen(!isTotalVestedOpen)} src="../images/icons/right.svg" />
                                                                    {!(poolState === 'OPEN_INVEST_PUBLIC' || poolState === 'OPEN_STAKER_FCFS') && (
                                                                        <>
                                                                            <span className='title'>Allocation</span>
                                                                            <span className='withdrawn-amount'>{Number(poolDetails.maxGuaranteed / poolDetails.tokenPrice).toFixed(4)} {poolDetails.tokenSymbol}</span>
                                                                        </>
                                                                    )}
                                                                    {(poolState === 'OPEN_INVEST_PUBLIC' || poolState === 'OPEN_STAKER_FCFS') && (
                                                                        <>
                                                                            <span className='title'>Minimum</span>
                                                                            <span className='withdrawn-amount'>{poolDetails.minInvest} USDT</span>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="token-distribution-view">
                                            <div className="token-distribution-title-container">
                                                <h6 className="join-now m-0 text-xxs">Token distribution</h6>
                                            </div>
                                            <div className="token-distribution-details-view mt-2">
                                                <div className="d-flex justify-content-between">
                                                    <p>Vesting</p>
                                                    <p>{poolDetails.vestingDescription}</p>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    <p className="mb-2">Distribution</p>
                                                    <p className="mb-2">{poolDetails.distributionDescription}</p>
                                                </div>
                                                {/* <div className="d-flex justify-content-between">
                                                    <p className="mb-0">Distribution</p>
                                                    <p className="mb-0">{poolDetails.distributionDescription}</p>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="project-details-page">
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="left-section">
                                            {/* <div className="project-details">
                                            <div className=" d-flex flex-row align-items-center">
                                                <div className="logo-container">
                                                    <img src={poolDetails.logoLink} />
                                                    <p className="mb-0">{poolDetails.chainName}</p>
                                                </div>
                                                <div className="text">
                                                    <h4 className="project-title mb-0 font-bold">{poolDetails.title}</h4>
                                                    <p className="project-description mb-0">{poolDetails.description}</p>
                                                </div>
                                            </div>
                                            <div className="project-social d-flex flex-row justify-content-end">
                                                <a className='website' href={poolDetails.website} target='_blank'>
                                                    <div className="social-item d-flex flex-column align-items-center">
                                                        <img alt="social website" className="social-icon mr-2" src="../images/social-website.png"></img>
                                                    </div>
                                                </a>
                                                <a className='twitter' href={"https://twitter.com/" + poolDetails.twitter} target='_blank'>
                                                    <div className="social-item d-flex flex-column align-items-center">
                                                        <img alt="social twitter" className="social-icon mr-2" src="../images/social-twitter.svg"></img>
                                                    </div>
                                                </a>
                                                <a className="telegram" href={"https://telegram.me/" + poolDetails.telegram} target='_blank'>
                                                    <div className="social-item d-flex flex-column align-items-center">
                                                        <img alt="social telegram" className="social-icon mr-2" src="../images/social-telegram.svg"></img>
                                                    </div>
                                                </a>
                                                <a className='pitchdeck' href={poolDetails.pitchDeck} target='_blank'>
                                                    <div className="social-item d-flex flex-column align-items-center">
                                                        <img alt="social pitchdeck" className="social-icon mr-2" src="../images/social-deck.png"></img>
                                                    </div>
                                                </a>
                                            </div>
                                        </div> */}

                                            {/* <div className="allocation-view">
                                            <div className="account-details-container col">
                                                <div className='claim-dashboard-item d-flex'>
                                                    <div className={`first-container flip-container ${isWithdrawOpen ? "flipped" : ""}`}>
                                                        <div className="flipcard-body">
                                                            <div className="front-container">
                                                                <div className="total-withdrawn d-flex align-items-center">
                                                                    <img className="flip-icon" onClick={() => setIsWithdrawOpen(!isWithdrawOpen)} src="../images/icons/right.svg" />
                                                                    <span className='title'>Token Price</span>
                                                                    <span className='withdrawn-amount'>1 {poolDetails.tokenSymbol} = ${(poolDetails.tokenPrice).toFixed(3)}</span>
                                                                </div>
                                                            </div>
                                                            <div className="back-container">
                                                                <div className="total-withdrawn d-flex align-items-center">
                                                                    <img className="flip-icon" onClick={() => setIsWithdrawOpen(!isWithdrawOpen)} src="../images/icons/right.svg" />
                                                                    <span className='title'> {isMobile ? "Accepted Cur." : "Accepted Currency"}</span>
                                                                    <span className='withdrawn-amount'>BSC-USDT</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`second-container flip-container ${isTotalVestedOpen ? "flipped" : ""}`}>
                                                        <div className="flipcard-body">
                                                            <div className="front-container">
                                                                <div className="total-withdrawn d-flex align-items-center">
                                                                    <img className="flip-icon" onClick={() => setIsTotalVestedOpen(!isTotalVestedOpen)} src="../images/icons/right.svg" />
                                                                    <span className='title'>Allocation</span>
                                                                    <span className='withdrawn-amount'>5000 USDT</span>
                                                                </div>
                                                            </div>
                                                            <div className="back-container">
                                                                <div className="total-withdrawn d-flex align-items-center">
                                                                    <img className="flip-icon" onClick={() => setIsTotalVestedOpen(!isTotalVestedOpen)} src="../images/icons/right.svg" />
                                                                    <span className='title'>Allocation</span>
                                                                    <span className='withdrawn-amount'>00 {poolDetails.tokenSymbol}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div> */}
                                            <div className="participate-and-progress-view">
                                                {/* <div className="participation-view">
                                                <div className="join-now-container">
                                                    <h6 className="join-now m-0 text-xxs">Participate IDO</h6>
                                                </div>
                                                <div className="participate-now">
                                                    <div className="form-content">
                                                        <Form className="d-flex flex-column">
                                                            <Form.Group className="mb-2 d-flex flex-column">
                                                                <Form.Label>{poolDetails.invetment > 0 ? "Your Investment" : "Your Investment"}</Form.Label>
                                                                <Form.Control
                                                                    className="form-input usdt-input"
                                                                    type="number"
                                                                    value={poolDetails.invetment > 0 ? poolDetails.invetment : Number(investAmount)}
                                                                    disabled={poolDetails.invetment > 0}
                                                                    onChange={({ target: { value } }) => {
                                                                        let val = Number(value)
                                                                        setInvestAmount(val)
                                                                    }} />
                                                            </Form.Group>
                                                            {poolDetails.invetment <= 0 && (<Button
                                                                className="button button-primary button-max"
                                                                variant="primary"
                                                                onClick={() => handleMaxButtonClick(poolState)}>MAX</Button>)}
                                                        </Form>
                                                        <h6>Receivable {poolDetails.tokenSymbol}: {poolDetails.invetment > 0 ? (poolDetails.invetment / poolDetails.tokenPrice) + ' ' + poolDetails.tokenSymbol : Number(reciveAmount)}</h6>
                                                        {!account && <Button
                                                            className="btn btn-brand btn-info"
                                                            >
                                                            Connect Your Wallet
                                                        </Button>}
                                                        {allowance && !isApproveDoneOrInProgress() && <Button
                                                            className="button button-primary "
                                                            variant="primary"
                                                            onClick={() => handleApprove()}
                                                            disabled={isApproveDoneOrInProgress()}>
                                                            Approve
                                                        </Button>}
                                                        {(!allowance || isApproveOrInvestOrClaimInProgress()) && <Button
                                                            className="button button-primary "
                                                            variant="primary"
                                                            // onClick={() => handleApprove()}
                                                            disabled={true}>
                                                            <PropagateLoader color={"#C2EAFF"} loading={true} />
                                                        </Button>}
                                                        {allowance && isApproveDone() && !requestedInvest && poolDetails.invetment <= 0 && !poolDetails.claimed && <Button
                                                            className="button button-primary "
                                                            variant="primary"
                                                            onClick={() => handleInvest()}
                                                            disabled={!isApproveDone()}>
                                                            Buy
                                                        </Button>}
                                                        {allowance && isApproveDone() && !requestedClaim && poolDetails.invetment > 0 && poolDetails.claimTracker === "0" && <Button
                                                            className="button button-primary "
                                                            variant="primary"
                                                            onClick={() => handleListingClaim()}
                                                            disabled={!isApproveDone() || poolState !== 'CLAIM_OPEN'}>
                                                            Claim
                                                        </Button>}
                                                        {allowance && isApproveDone() && !requestedClaim && poolDetails.invetment > 0 && Number(poolDetails.claimTracker) > 0 && Number(poolDetails.claimTracker) < (Number(poolDetails.vestingIteration) + 1) && <Button
                                                            className="button button-primary "
                                                            variant="primary"
                                                            onClick={() => handleVestingClaim()}
                                                            disabled={!isApproveDone() || poolState !== 'CLAIM_OPEN' || getClaimableVesting(poolDetails) === 0}>
                                                            Claim
                                                        </Button>}
                                                        {allowance && isApproveDone() && !requestedClaim && poolDetails.invetment > 0 && Number(poolDetails.claimTracker) === (Number(poolDetails.vestingIteration) + 1) && <Button
                                                            className="button button-primary "
                                                            variant="primary"
                                                            // onClick={() => handleClaim()}
                                                            disabled={true}>
                                                            Claimed Sucessfully
                                                        </Button>}
                                                    </div>
                                                    {poolDetails.openTime  < Date.now() && poolDetails.closeTime  > Date.now() && ((poolState === 'OPEN_INVEST_STAKER' && poolDetails.totalCollected < poolDetails.hardCap)
                                                        || (poolState !== 'OPEN_INVEST_STAKER' && (Number(poolDetails.totalCollected) + Number(poolDetails.minInvest)) < poolDetails.hardCap)) && !poolDetails.isWhitlisted && poolState === "OPEN_INVEST_STAKER" &&
                                                        <div className="overlay-error-content">
                                                            <h6>You are not whitelisted</h6>
                                                        </div>}
                                                    {poolDetails.invetment <= 0 && ((poolState === 'OPEN_INVEST_STAKER' && poolDetails.totalCollected >= poolDetails.hardCap)
                                                        || (poolState !== 'OPEN_INVEST_STAKER' && (Number(poolDetails.totalCollected) + Number(poolDetails.minInvest)) >= poolDetails.hardCap)) &&
                                                        <div className="overlay-error-content">
                                                            <h6>Sale is filled</h6>
                                                        </div>}
                                                </div>
                                            </div> */}
                                                {/* <div className="progress-view">
                                                {(poolState === 'TBA' || poolState === 'WHITLIST_WILL_OPEN' || poolState === 'WHITLIST_IS_ON') && (
                                                    <>
                                                        <div className='d-flex align-items-center'>
                                                            <div className={ poolState == 'WHITLIST_IS_ON' ? "w-100 progress-bar-container" : "w-100" }>
                                                                <div>
                                                                    <RangeSlider
                                                                        className="range-slider"
                                                                        custom={true}
                                                                        // value={0}
                                                                        value={60}
                                                                        type='range'
                                                                        readOnly={true}
                                                                    />
                                                                </div>
                                                                <div className='d-flex justify-content-between'>
                                                                    <small className='mb-0'>Exculsive: {70}%</small>
                                                                    <small className='mb-0'>{30}%: Community</small>
                                                                </div>
                                                            </div>
                                                            {poolState == 'WHITLIST_IS_ON' && (
                                                                <div>
                                                                    <a className='btn btn-brand' href="https://blockius.typeform.com/deadknight" target={"_blank"}>Whitelist</a>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </>
                                                )}
                                                {(poolState === 'POOL_WILL_OPEN' || poolState === 'OPEN_INVEST_STAKER' || poolState === 'OPEN_STAKER_FCFS' || poolState === 'OPEN_INVEST_PUBLIC' || poolState === 'CLAIM_OPEN' || poolState === 'CLAIM_TO_BE_OPEN' || poolState === 'FILLED' || poolState === 'CLOSED' || poolState === 'CANCELLED') && (
                                                    <>
                                                        <div>
                                                            <RangeSlider
                                                                className="range-slider"
                                                                custom={true}
                                                                // value={0}
                                                                value={poolDetails.totalCollected > 0 ? poolDetails.totalRaise / poolDetails.totalCollected * 100 : 0}
                                                                type='range'
                                                                readOnly={true}
                                                            />
                                                        </div>
                                                        <div className='d-flex justify-content-between'>
                                                            <small className='mb-0'>{poolDetails.totalCollected > 0 ? poolDetails.totalRaise / poolDetails.totalCollected * 100 : 0} %</small>
                                                            <small className='mb-0'>{Number(poolDetails.totalCollected).toLocaleString()} / {Number(poolDetails.hardCap).toLocaleString()} USDT</small>
                                                        </div>
                                                    </>
                                                )}
                                                
                                            </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-6 col-sm-12">
                                    <div className="right-section">
                                        <div className="pool-timeline">
                                            <div className="main">
                                                <div className="timeline">
                                                    <div className="pool-status">
                                                        {poolState === 'TBA' && (
                                                            <h6 className="m-0 text-xxs interval">
                                                                TBA
                                                            </h6>
                                                        )}
                                                        {poolState === 'WHITLIST_WILL_OPEN' && (
                                                            <h6 className="m-0 text-xxs interval">
                                                                Whitelist Opens In {formatDuration(intervalToDuration({ start: new Date(poolDetails.whitelistingOpenTime), end: new Date() }), { format: ['years', 'months', 'weeks', 'days', 'hours', 'minutes'], delimiter: ' ' })}
                                                            </h6>
                                                        )}
                                                        {poolState === 'WHITLIST_IS_ON' && (
                                                            <h6 className="m-0 text-xxs interval">
                                                                Whitelist Closes In {formatDuration(intervalToDuration({ start: new Date(), end: new Date(poolDetails.whitelistingCloseTime) }), { format: ['years', 'months', 'weeks', 'days', 'hours', 'minutes'], delimiter: ' ' })}
                                                            </h6>
                                                        )}
                                                        {poolState === 'POOL_WILL_OPEN' && (
                                                            <h6 className="m-0 text-xxs interval">
                                                                Opens In {formatDuration(intervalToDuration({ start: new Date(poolDetails.openTime), end: new Date() }), { format: ['years', 'months', 'weeks', 'days', 'hours', 'minutes'], delimiter: ' ' })}
                                                            </h6>
                                                        )}
                                                        {(poolState === 'OPEN_INVEST_STAKER' || poolState === 'OPEN_STAKER_FCFS' || poolState === 'OPEN_INVEST_PUBLIC') && (
                                                            <h6 className="m-0 text-xxs open">
                                                                Open
                                                            </h6>
                                                        )}
                                                        {(poolState === 'FILLED' || poolState === 'CLOSED') && (
                                                            <h6 className="m-0 text-xxs filled">
                                                                Filled
                                                            </h6>
                                                        )}
                                                    </div>
                                                    <div className="box">
                                                        <div className="container">
                                                            <div className="lines">
                                                                <div className="dot"></div>
                                                                <div className="line"></div>
                                                                <div className="dot"></div>
                                                                <div className="line"></div>
                                                                <div className="dot"></div>
                                                                <div className="line"></div>
                                                                <div className="dot"></div>
                                                                <div className="line"></div>
                                                                <div className="dot"></div>
                                                                <div className="line"></div>
                                                                <div className="dot"></div>
                                                            </div>
                                                            <div className="cards">
                                                                <div className="card">
                                                                    <h6>Whitlist</h6>
                                                                    <h6 className="mb-0">{format(addMinutes(new Date(poolDetails.whitelistingOpenTime), new Date(poolDetails.whitelistingOpenTime) .getTimezoneOffset()) , 'dd MMM yyyy, HH:mm')} UTC</h6>
                                                                    <h6>{format(addMinutes(new Date(poolDetails.whitelistingCloseTime), new Date(poolDetails.whitelistingCloseTime) .getTimezoneOffset()) , 'dd MMM yyyy, HH:mm')} UTC</h6>
                                                                </div>
                                                                <div className="card mid">
                                                                    <h6>Round - 1</h6>
                                                                    <h6>{format(addMinutes(new Date(poolDetails.openTime), new Date(poolDetails.openTime) .getTimezoneOffset()) , 'dd MMM yyyy, HH:mm')} - {format(addMinutes(new Date(poolDetails.poolStakerFCFS), new Date(poolDetails.poolStakerFCFS) .getTimezoneOffset()) , 'HH:mm')} UTC</h6>
                                                                </div>
                                                                <div className="card mid">
                                                                    <h6>Round - 2</h6>
                                                                    <h6>{format(addMinutes(new Date(poolDetails.poolStakerFCFS) , new Date(poolDetails.poolStakerFCFS) .getTimezoneOffset()) , 'dd MMM yyyy, HH:mm')} - {format(addMinutes(new Date(poolDetails.poolOpenPublic) , new Date(poolDetails.poolOpenPublic) .getTimezoneOffset()) , 'HH:mm')} UTC</h6>
                                                                </div>
                                                                <div className="card mid">
                                                                    <h6>Round - 3</h6>
                                                                    <h6>{format(addMinutes(new Date(poolDetails.poolOpenPublic) , new Date(poolDetails.poolOpenPublic) .getTimezoneOffset()) , 'dd MMM yyyy, HH:mm')} - {format(addMinutes(new Date(poolDetails.closeTime) , new Date(poolDetails.closeTime) .getTimezoneOffset()) , ' HH:mm')} UTC</h6>
                                                                </div>
                                                                <div className="card last">
                                                                    <h6>Sale Filled</h6>
                                                                </div>
                                                                <div className="card mid">
                                                                    <h6>Listing :- Pancake</h6>
                                                                    <h6>{format(addMinutes(new Date(poolDetails.poolOpenPublic) , new Date(poolDetails.poolOpenPublic) .getTimezoneOffset()) , 'dd MMM yyyy, HH:mm')} - {format(addMinutes(new Date(poolDetails.closeTime) , new Date(poolDetails.closeTime) .getTimezoneOffset()) , ' HH:mm')} UTC</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                </div>
                            </div>
                            <Modal
                                show={solanaModalShow}
                                onHide={() => setSolanaModalShow(false)}
                                // size="sm"
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title className="ml-auto" id="contained-modal-title-vcenter">
                                        Add Solana Address
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="px-5 py-4">
                                    {poolDetails && (
                                        <Form className="d-flex flex-column flot-form">
                                            <Form.Group className="m-0 d-flex flex-column ">
                                                <div className="d-flex flex-column mb-3">
                                                    <Form.Label className="text-nowrap">Enter Solana Address</Form.Label>
                                                    <Form.Control
                                                        className="form-input solana-input"
                                                        type="text"
                                                        placeholder="Enter Your Solana Address"
                                                        disabled={!isSolanaEditable}
                                                        value={solanaAddress}
                                                        onChange={({ target: { value } }) => {
                                                            setSolanaAddress(value)
                                                        }} />
                                                </div>
                                                <Button
                                                    className="btn btn-brand"
                                                    onClick={() => {
                                                        isSolanaEditable ? handleSolanaSubmit() : setSolanaEditable(true)
                                                    }}
                                                >
                                                    {isSolanaEditable ? "Submit" : "Edit"}
                                                </Button>
                                            </Form.Group>
                                        </Form>
                                    )}
                                </Modal.Body>
                            </Modal>
                        </>
                    )}
                </div>
            </section>
        </Container>
    )
}
export default PoolDetailsPage;